/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  ApplyBrandStyleRequest,
  BeeContentDTO,
  BeeCreateFileDTO,
  BeeMediaResponseDTO,
  CreateBeeTemplateDTO,
  JsonNode,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getBeeMedia = () => {
  /**
   * Takes a Bee Plugin JSON and returns their HTML
   */
  const process = (createBeeTemplateDTO: CreateBeeTemplateDTO) => {
    return customInstance<string>({
      url: `/api/bee/process-json`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createBeeTemplateDTO,
    });
  };
  /**
   * Creates a directory or uploads a file to BEE plugin storage for the client resolved from the BEE basic auth token.
   * @summary Create a BEE plugin directory or upload a file
   */
  const createFile = (beeCreateFileDTO: BeeCreateFileDTO) => {
    return customInstance<BeeMediaResponseDTO>({
      url: `/api/bee/media/**`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: beeCreateFileDTO,
    });
  };
  /**
   * Deletes a file from BEE plugin storage for the client resolved from the BEE basic auth token.
   * @summary Delete a BEE plugin media file
   */
  const deleteFile = () => {
    return customInstance<BeeMediaResponseDTO>({ url: `/api/bee/media/**`, method: "DELETE" });
  };
  /**
   * Converts HTML to BEE Plugin JSON format
   */
  const convertHtmlToJson = (jsonNode: JsonNode) => {
    return customInstance<string>({
      url: `/api/bee/html-to-json`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: jsonNode,
    });
  };
  /**
   * Applies brand styles to BEE JSON by touchpoint version ID
   */
  const applyBrandStyles = (applyBrandStyleRequest: ApplyBrandStyleRequest) => {
    return customInstance<BeeContentDTO>({
      url: `/api/bee/apply-brand-styles`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: applyBrandStyleRequest,
    });
  };
  /**
   * Lists the BEE plugin media directories for the client resolved from the BEE basic auth token.
   * @summary List BEE plugin media directories
   */
  const getDirectory = () => {
    return customInstance<BeeMediaResponseDTO>({ url: `/api/bee/media/`, method: "GET" });
  };
  return { process, createFile, deleteFile, convertHtmlToJson, applyBrandStyles, getDirectory };
};
export type ProcessResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getBeeMedia>["process"]>>
>;
export type CreateFileResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getBeeMedia>["createFile"]>>
>;
export type DeleteFileResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getBeeMedia>["deleteFile"]>>
>;
export type ConvertHtmlToJsonResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getBeeMedia>["convertHtmlToJson"]>>
>;
export type ApplyBrandStylesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getBeeMedia>["applyBrandStyles"]>>
>;
export type GetDirectoryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getBeeMedia>["getDirectory"]>>
>;
